import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

import { requestTrack } from "@Components/Modules/Helpers";

import useAjax from "./useAjax";

type IUseAjaxVisibility<TResult extends object> = {
    ajaxAction?: string;
    rootMargin?: string;
    ajaxTrack?: string;
    initialData?: TResult;
    initialInView?: boolean;
};

const useAjaxVisibility = <TResult extends object>({
    ajaxAction,
    rootMargin,
    ajaxTrack,
    initialData,
    initialInView,
}: IUseAjaxVisibility<TResult>) => {
    const { request, data, isLoading } = useAjax<TResult>({ ajaxAction, initialData });
    const [refObj, inView] = useInView({ triggerOnce: true, rootMargin, initialInView });

    useEffect(() => {
        if (inView) {
            if (ajaxAction && !initialData) {
                request();
            }
            if (ajaxTrack) {
                requestTrack(ajaxTrack);
            }
        }
    }, [inView, ajaxAction]);

    return { refObj, data, isLoading, request };
};

export default useAjaxVisibility;
